import React from "react";
import "./HeroSection.css";
import Logo from "./Assets/Logo - light theme.png";

import ellipse from "./Assets/Ellipse 3.png";
import gradientBlob from "./Assets/Group 1171275315.png"; // 🔥 SECOND IMAGE

import Card from "./Card";
import ProductsSection from "./ProductsSection";
import ProductCarousel from "./HeroCarousel";
import Footer from "./Footer";
import NewProducts from "./NewProduct";

const HeroSection = () => {

    const handleLearnMoreClick = () => {
        const cardSection = document.getElementById("card-section");
        if (cardSection) {
            cardSection.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <>
            <section className="hero">

                {/* Logo */}
                <div className="hero-logo">
                    <img src={Logo} alt="Kushmanda Logo" className="logo-image" />
                </div>

                {/* Left ellipse */}
                <img src={ellipse} className="hero-ellipse" alt="decor" />

                {/* 🔥 Gradient image (replaces blur background) */}
                <img
                    src={gradientBlob}
                    alt="gradient glow"
                    className="hero-gradient-image"
                />

                {/* Content */}
                <div className="hero-inner">
                    <h1 className="hero-heading">
                        Building products <br />
                        <span className="highlight with-corners">
                            <span className="corner top-left"></span>
                            <span className="corner top-right"></span>
                            millions
                            <span className="corner bottom-left"></span>
                            <span className="corner bottom-right"></span>
                        </span>
                        will love.
                    </h1>

                    <div className="cta-row">
                        <button className="cta" onClick={handleLearnMoreClick}>
                            Learn More
                        </button>
                        <p className="hero-text">
                            Kushmanda began with a simple belief:<br/> a small team with strong principles,<br/> unwavering persistence, and the <br/>courage to reinvent itself can build <br/>something valuable.
                        </p>


                    </div>
                </div>
            </section>
            <ProductsSection />

            {/* Target */}
            <div id="card-section">
                <Card />
            </div>

            <NewProducts />
            <ProductCarousel />
            <Footer />
        </>
    );
};

export default HeroSection;
